/**
 * Frontend credit system constants
 * Mirror of backend constants for consistent behavior
 */

/**
 * Credit balance thresholds for UI warnings
 */
export const CREDIT_THRESHOLDS = {
  LOW_BALANCE: 5, // Show warning when balance is below this
  MINIMUM_BALANCE: 0, // Minimum allowed balance
} as const;

/**
 * Credit costs for different operations
 * Should match backend CREDIT_COSTS
 */
export const CREDIT_COSTS = {
  CONCEPT_GENERATION: 1,
  LLM_GENERATION: 1,
  MATERIAL_REPLACEMENT: 1,
  USER_EDIT: 1,
} as const;
